import { createAction } from '@ngrx/store';

export const updateLastActiveAction = createAction('[Profile] Set last active to current time');

export const initProfileAction = createAction('[Profile] Init Profile Action');
